import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
} from "@mui/material";
import moment from "moment";
import Select from "react-select";
import {
  adminOfferDate,
  getDoctorsByConsultationId,
} from "../../../config/service";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./OfferDateModal.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  glassDialogPaperProps,
  glassDialogBackdropProps,
  GLASS_DIALOG_ROOT_SX_PORTAL_FRIENDLY,
  GLASS_DIALOG_TITLE_SX,
} from "./consultationsGlassDialog";

/** Consultations route only — glass UI. Meeting list uses legacy `./OfferDate`. */
function ConsultationsOfferDateModal(props) {
  const {
    offerModal,
    offerMeetingId,
    handleCloseModal,
    consultId,
    mstatus,
    requestedDates,
    assapValue,
  } = props;
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const dir = lang === "HE" ? "rtl" : "ltr";
  const [firstDate, setFirstDate] = useState(new Date());
  const [secondDate, setSecondDate] = useState(new Date());
  const navigate = useNavigate();
  const [doctorList, setDoctorList] = useState([]);
  const [doctor, setDoctor] = useState();

  const selectStyles = useMemo(
    () => ({
      control: (base, state) => ({
        ...base,
        borderRadius: 12,
        minHeight: 44,
        borderColor: state.isFocused
          ? "rgba(79, 70, 229, 0.5)"
          : "rgba(148, 163, 184, 0.32)",
        backgroundColor: "rgba(248, 250, 252, 0.72)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        boxShadow: state.isFocused
          ? "0 0 0 3px rgba(79, 70, 229, 0.12)"
          : "none",
        "&:hover": {
          borderColor: "rgba(99, 102, 241, 0.38)",
        },
      }),
      menu: (base) => ({
        ...base,
        borderRadius: 12,
        border: "1px solid rgba(148, 163, 184, 0.22)",
        boxShadow:
          "0 12px 28px rgba(15,23,42,0.1), inset 0 1px 0 rgba(255,255,255,0.5)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.96), rgba(248,250,252,0.9))",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        overflow: "hidden",
        zIndex: 1700,
      }),
      menuPortal: (base) => ({ ...base, zIndex: 1700 }),
      option: (base, state) => ({
        ...base,
        textAlign: dir === "rtl" ? "right" : "left",
        backgroundColor: state.isSelected
          ? "rgba(79, 70, 229, 0.14)"
          : state.isFocused
            ? "rgba(241, 245, 249, 0.95)"
            : "transparent",
        color: "rgba(30, 41, 59, 0.95)",
        fontWeight: state.isSelected ? 600 : 400,
      }),
      singleValue: (base) => ({
        ...base,
        textAlign: dir === "rtl" ? "right" : "left",
        color: "rgba(30, 41, 59, 0.92)",
      }),
      placeholder: (base) => ({
        ...base,
        textAlign: dir === "rtl" ? "right" : "left",
        color: "rgba(100, 116, 139, 0.75)",
      }),
      input: (base) => ({
        ...base,
        textAlign: dir === "rtl" ? "right" : "left",
      }),
    }),
    [dir]
  );

  /** Block manual typing in date fields (keyboard opens calendar only). */
  const preventDatePickerKeyDown = useCallback((event) => {
    event.preventDefault();
  }, []);

  useEffect(() => {
    if (consultId) {
      alldoctorList(consultId);
    }
    setDoctor(
      props.offerDates && props.offerDates.length != 0
        ? props.offerDates[0].DoctorId
        : ""
    );
  }, [consultId]);

  useEffect(() => {
    setFirstDate();
    setSecondDate();
  }, [handleCloseModal]);

  const shift = (d) => {
    let shifttime = "";
    if (["8", "9", "10", "11"].includes(d)) {
      shifttime = "Morning";
    }
    if (["12", "13", "14", "15"].includes(d)) {
      shifttime = "Afternoon";
    }
    if (["16", "17", "18", "19", "20", "21", "22"].includes(d)) {
      shifttime = "Evening";
    }

    return shifttime;
  };
  const Offer = async (e) => {
    e.preventDefault();
    let DateTime = [];

    if (mstatus === "DatesOffered") {
      !firstDate &&
        props.offerDates &&
        props.offerDates.length != 0 &&
        DateTime.push(moment(props.offerDates[0]?.offeredDates[0]).toDate());
      firstDate && DateTime.push(moment(firstDate).toDate());

      !secondDate &&
        props.offerDates &&
        props.offerDates.length != 0 &&
        props.offerDates[0]?.offeredDates[1] &&
        DateTime.push(moment(props.offerDates[0]?.offeredDates[1]).toDate());
      secondDate && DateTime.push(moment(secondDate).toDate());
    } else {
      firstDate && DateTime.push(moment(firstDate).toDate());
      secondDate && DateTime.push(moment(secondDate).toDate());
    }

    const data = {
      id: offerMeetingId,
      offeredDates: DateTime,
      doctorId: doctor,
    };
    if (doctor) {
      const response = await adminOfferDate(data);
      response.data.message
        ? toast.success(t(response.data.message))
        : toast.success(t(response.data.msg));
      handleCloseModal();
      props.AllApoinmentDoctor?.({ val: "Created" });
    } else {
      toast.error(t("Please select doctor"));
    }
  };
  const alldoctorList = async (data) => {
    try {
      const response = await getDoctorsByConsultationId(data);
      setDoctorList(response.data.doctors);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
      console.log(error);
    }
  };
  let datearray = [];
  const filterdata = (data) => {
    if (datearray.includes(moment(data).format("DD.MM.YYYY"))) {
      return true;
    } else {
      datearray.push(moment(data).format("DD.MM.YYYY"));
      return false;
    }
  };

  const doctorOptions = doctorList.map((d) => ({
    value: d?.doctorData._id,
    label: `${d?.doctorData.first_name} ${d?.doctorData.last_name}`,
  }));

  const defaultValue =
    props.offerDates && props.offerDates.length !== 0
      ? doctorOptions.find(
          (data) =>
            data.value ===
            doctorList.find(
              (doc) => doc.doctorId === props.offerDates[0].DoctorId
            )?.doctorData._id
        )
      : { value: "placeholdervalue", label: t("Select doctor") };

  const handleDoctorChange = (selectedOption) => {
    setDoctor(selectedOption.value);
  };

  return (
    <Dialog
      open={offerModal}
      onClose={handleCloseModal}
      dir={dir}
      maxWidth="sm"
      fullWidth
      className="offer-date-modal"
      aria-labelledby="offer-date-modal-title"
      PaperProps={glassDialogPaperProps({
        overflow: "visible",
        maxWidth: 560,
        width: "100%",
      })}
      sx={GLASS_DIALOG_ROOT_SX_PORTAL_FRIENDLY}
      BackdropProps={glassDialogBackdropProps()}
    >
      <DialogTitle
        id="offer-date-modal-title"
        sx={[
          GLASS_DIALOG_TITLE_SX,
          { pb: 0.5, pt: 3 },
        ]}
      >
        {t("Please choose/provide a date for consult")}
      </DialogTitle>
      <DialogContent
        sx={{
          px: { xs: 2.5, sm: 3.5 },
          pt: 1,
          pb: 2.5,
          overflow: "visible",
        }}
      >
        <Stack spacing={2}>
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "rgba(30, 41, 59, 0.88)",
                mb: 0.5,
                textAlign: "center",
              }}
            >
              {t("Requested dates")}
            </Typography>
            {assapValue ? (
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(37, 99, 235, 0.9)",
                  textAlign: "center",
                  fontWeight: 500,
                }}
              >
                {t("ASAP")}
              </Typography>
            ) : requestedDates && requestedDates.length != 0 ? (
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: dir === "rtl" ? 0 : 2,
                  pr: dir === "rtl" ? 2 : 0,
                  listStyle: "none",
                  color: "rgba(37, 99, 235, 0.88)",
                  textAlign: "center",
                }}
              >
                {[...requestedDates].sort().map((d, idx) => {
                  return filterdata(d) ? (
                    <Typography
                      key={`s-${idx}`}
                      component="span"
                      variant="body2"
                      sx={{ display: "inline" }}
                    >
                      {t(shift(moment(d).format("H")))}{" "}
                    </Typography>
                  ) : (
                    <Typography
                      key={`d-${idx}`}
                      component="li"
                      variant="body2"
                      sx={{ mt: 0.5 }}
                    >
                      {`${moment(d).format("DD.MM.YYYY")} ${t(
                        shift(moment(d).format("H"))
                      )}`}
                    </Typography>
                  );
                })}
              </Box>
            ) : null}
          </Box>

          {props.offerDates && props.offerDates.length != 0 ? (
            <Box
              sx={{
                p: 1.5,
                borderRadius: "12px",
                border: "1px solid rgba(148, 163, 184, 0.22)",
                bgcolor: "rgba(255,255,255,0.45)",
                backdropFilter: "blur(8px)",
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, mb: 1, textAlign: "center" }}
              >
                {t("Dates are already offered for this meeting")}
              </Typography>
              <Box
                component="ul"
                sx={{
                  m: 0,
                  pl: dir === "rtl" ? 0 : 2,
                  pr: dir === "rtl" ? 2 : 0,
                  textAlign: "center",
                }}
              >
                {props.offerDates.map((d, i) => (
                  <React.Fragment key={i}>
                    {doctorList &&
                      d.offeredDates.map((d1, k) => (
                        <Typography
                          key={`${i}-${k}`}
                          component="li"
                          variant="body2"
                          sx={{ color: "rgba(51, 65, 85, 0.92)" }}
                        >
                          {moment(d1).format("H:mm")}{" "}
                          {moment(d1).format("DD.MM.YYYY")}{" "}
                          {
                            doctorList.find(
                              (data) => data.doctorId === d.DoctorId
                            )?.doctorData?.first_name
                          }{" "}
                          {
                            doctorList.find(
                              (data) => data.doctorId === d.DoctorId
                            )?.doctorData?.last_name
                          }
                        </Typography>
                      ))}
                  </React.Fragment>
                ))}
              </Box>
            </Box>
          ) : null}

          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "rgba(30, 41, 59, 0.88)",
                mb: 1,
                textAlign: "center",
              }}
            >
              {t("Doctor List")}
            </Typography>
            {doctorList && doctorList[0]?.doctorData.first_name && (
              <Select
                classNamePrefix="offer-date-select"
                defaultValue={defaultValue}
                isRtl={lang === "HE"}
                menuPortalTarget={
                  typeof window !== "undefined" ? window.document.body : null
                }
                menuPosition="fixed"
                styles={selectStyles}
                noOptionsMessage={() => t("No option available")}
                isSearchable={true}
                options={doctorOptions}
                placeholder={t("Select doctor")}
                name="doctor_list"
                onChange={handleDoctorChange}
              />
            )}
          </Box>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            sx={{ alignItems: "stretch" }}
          >
            <Box sx={{ flex: 1, minWidth: 0, direction: "ltr" }}>
              <DatePicker
                id="offer-date-first"
                selected={
                  firstDate
                    ? firstDate
                    : props.offerDates?.[0]?.offeredDates?.[0]
                    ? moment(props.offerDates[0].offeredDates[0]).toDate()
                    : firstDate
                }
                onChange={(date) => setFirstDate(date)}
                onKeyDown={preventDatePickerKeyDown}
                minDate={new Date()}
                minTime={
                  new Date(
                    firstDate || props.offerDates?.[0]?.offeredDates?.[0]
                  ).getDate() > new Date().getDate() ||
                  new Date(
                    firstDate || props.offerDates?.[0]?.offeredDates?.[0]
                  ).getMonth() > new Date().getMonth()
                    ? new Date().setHours(7, 0, 0, 0)
                    : new Date().setHours(new Date().getHours() + 0, 30, 0, 0)
                }
                maxTime={new Date().setHours(21, 30, 0, 0)}
                className="offer-date-modal-input"
                timeIntervals={15}
                showTimeSelect
                popperClassName="offer-date-datepicker-popper"
                portalId="offer-date-portal-first"
                popperPlacement="bottom-start"
                dateFormat="MMMM d, yyyy HH:mm"
                timeFormat="HH:mm"
                placeholderText={t("Offer Date")}
                wrapperClassName="offer-date-picker-wrap"
              />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, direction: "ltr" }}>
              <DatePicker
                id="offer-date-second"
                selected={
                  secondDate
                    ? secondDate
                    : props.offerDates?.[0]?.offeredDates?.[1]
                    ? moment(props.offerDates[0].offeredDates[1]).toDate()
                    : secondDate
                }
                onChange={(date) => setSecondDate(date)}
                onKeyDown={preventDatePickerKeyDown}
                minDate={new Date()}
                minTime={
                  new Date(
                    secondDate || props.offerDates?.[0]?.offeredDates?.[1]
                  ).getDate() > new Date().getDate() ||
                  new Date(
                    secondDate || props.offerDates?.[0]?.offeredDates?.[1]
                  ).getMonth() > new Date().getMonth()
                    ? new Date().setHours(7, 0, 0, 0)
                    : new Date().setHours(new Date().getHours() + 0, 30, 0, 0)
                }
                maxTime={new Date().setHours(21, 30, 0, 0)}
                className="offer-date-modal-input"
                dateFormat="MMMM d, yyyy HH:mm"
                timeFormat="HH:mm"
                timeIntervals={15}
                showTimeSelect
                popperClassName="offer-date-datepicker-popper"
                portalId="offer-date-portal-second"
                popperPlacement="bottom-start"
                placeholderText={t("Offer Date")}
                wrapperClassName="offer-date-picker-wrap"
              />
            </Box>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2.5, sm: 3.5 },
          pb: 3,
          pt: 0,
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          onClick={Offer}
          disabled={!firstDate && !secondDate}
          sx={{
            minWidth: 200,
            borderRadius: 999,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
            py: 1.15,
            px: 4,
            boxShadow: "0 10px 28px rgba(67, 56, 202, 0.32)",
            bgcolor: "rgba(67, 56, 202, 0.96)",
            "&:hover": {
              bgcolor: "rgba(55, 48, 163, 0.98)",
              boxShadow: "0 12px 32px rgba(67, 56, 202, 0.38)",
            },
            "&.Mui-disabled": {
              bgcolor: "rgba(148, 163, 184, 0.45)",
              color: "rgba(255,255,255,0.9)",
            },
          }}
        >
          {t("Offer Date")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConsultationsOfferDateModal;
